import { Injectable, type Provider } from '@angular/core';
import { type Params, RouteReuseStrategy, BaseRouteReuseStrategy, type ActivatedRouteSnapshot } from '@angular/router';

export const REUSE_ON_PARAM_CHANGE = 'reuseOnParamChange';

@Injectable()
class RecreateOnParamChangeStrategy extends BaseRouteReuseStrategy {
  public override shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(future, current)) {
      return false;
    }

    const reuseOnParamChange = future.routeConfig?.data?.[REUSE_ON_PARAM_CHANGE] === true;

    return reuseOnParamChange || sameParams(future.params, current.params);
  }
}

function sameParams(a: Params, b: Params): boolean {
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every((key) => a[key] === b[key]);
}

export function provideRouteReuseStrategy(): Provider {
  return {
    provide: RouteReuseStrategy,
    useClass: RecreateOnParamChangeStrategy,
  };
}
